import {
  ADD_COLLABORATORS,
  CREATE_COLLABORATOR_FAILED,
  CREATE_COLLABORATOR_SUCCESS,
  CREATING_COLLABORATOR,
  CollaboratorsDataTypes,
  DELETE_COLLABORATOR_FAILED,
  DELETE_COLLABORATOR_SUCCESS,
  DELETING_COLLABORATOR,
  ENABLE_COLLABORATOR_FAILED,
  ENABLE_COLLABORATOR_SUCCESS,
  ENABLING_COLLABORATOR,
  FETCHING_COLLABORATORS,
  FETCH_COLLABORATORS_FAILED,
  LOGOUT,
  LogoutActionTypes,
  UPDATE_COLLABORATOR_FAILED,
  UPDATE_COLLABORATOR_SUCCESS,
  UPDATING_COLLABORATOR,
} from '../config/ActionTypes';
import { Collaborator, CollaboratorResponse, CollaboratorsState } from '../config/types';

export const initialState: CollaboratorsState = {
  loadingCollaborators: false,
  collaborators: null,
  collaboratorsErrorMessage: null,
  creatingCollaborator: false,
  createCollaboratorSuccess: false,
  createCollaboratorErrorMessage: null,
  updatingCollaborator: false,
  updateCollaboratorSuccess: false,
  updateCollaboratorErrorMessage: null,
  deletingCollaborator: false,
  deleteCollaboratorSuccess: false,
  deleteCollaboratorErrorMessage: null,
  enablingCollaborator: false,
  enableCollaboratorSuccess: false,
  enableCollaboratorErrorMessage: null,
};

function isCollaboratorResponse(
  response: Collaborator[] | CollaboratorResponse,
): response is CollaboratorResponse {
  return response !== undefined && (response as CollaboratorResponse).users !== undefined;
}

export function collaboratorsReducer(
  state = initialState,
  action: CollaboratorsDataTypes | LogoutActionTypes,
): CollaboratorsState {
  switch (action.type) {
    case FETCHING_COLLABORATORS:
      return {
        ...state,
        loadingCollaborators: true,
        collaborators: null,
        collaboratorsErrorMessage: null,
      };

    case ADD_COLLABORATORS:
      let collaborators: Collaborator[] = [];

      collaborators = isCollaboratorResponse(action.collaboratorsResponse)
        ? action.collaboratorsResponse.users
        : action.collaboratorsResponse;

      return {
        ...state,
        loadingCollaborators: false,
        collaborators: collaborators,
        collaboratorsErrorMessage: null,
      };

    case FETCH_COLLABORATORS_FAILED:
      return {
        ...state,
        loadingCollaborators: false,
        collaborators: null,
        collaboratorsErrorMessage: action.error,
      };

    case CREATING_COLLABORATOR:
      return {
        ...state,
        creatingCollaborator: true,
        createCollaboratorSuccess: false,
        createCollaboratorErrorMessage: null,
      };

    case CREATE_COLLABORATOR_SUCCESS:
      const newCollaborators = state.collaborators ? [...state.collaborators] : [];
      newCollaborators.push({ ...action.collaborator, active: true });

      return {
        ...state,
        collaborators: newCollaborators,
        creatingCollaborator: false,
        createCollaboratorSuccess: true,
        createCollaboratorErrorMessage: null,
      };

    case CREATE_COLLABORATOR_FAILED:
      return {
        ...state,
        creatingCollaborator: false,
        createCollaboratorSuccess: false,
        createCollaboratorErrorMessage: action.error,
      };

    case UPDATING_COLLABORATOR:
      return {
        ...state,
        updatingCollaborator: true,
        updateCollaboratorSuccess: false,
        updateCollaboratorErrorMessage: null,
      };

    case UPDATE_COLLABORATOR_SUCCESS:
      let updatedCollaborators = state.collaborators?.map((collaborator: Collaborator) => {
        if (collaborator.userId === action.collaborator.userId) {
          let returnedCollaborator: Collaborator = {
            ...collaborator,
            names: action.collaborator.names,
            surnames: action.collaborator.surnames,
          };

          return returnedCollaborator;
        }

        return collaborator;
      });

      return {
        ...state,
        updatingCollaborator: false,
        updateCollaboratorSuccess: true,
        collaborators: updatedCollaborators || [],
        updateCollaboratorErrorMessage: null,
      };

    case UPDATE_COLLABORATOR_FAILED:
      return {
        ...state,
        updatingCollaborator: false,
        updateCollaboratorSuccess: false,
        updateCollaboratorErrorMessage: action.error,
      };

    case DELETING_COLLABORATOR:
      return {
        ...state,
        deletingCollaborator: true,
        deleteCollaboratorSuccess: false,
        deleteCollaboratorErrorMessage: null,
      };

    case DELETE_COLLABORATOR_SUCCESS:
      const nonDeletedCollaborators =
        state.collaborators &&
        state.collaborators.filter(
          (collaborator: Collaborator) => collaborator.userId !== action.collaboratorId,
        );

      return {
        ...state,
        deletingCollaborator: false,
        deleteCollaboratorSuccess: true,
        collaborators: nonDeletedCollaborators,
        deleteCollaboratorErrorMessage: null,
      };

    case DELETE_COLLABORATOR_FAILED:
      return {
        ...state,
        deletingCollaborator: false,
        deleteCollaboratorSuccess: false,
        deleteCollaboratorErrorMessage: action.error,
      };

    case ENABLING_COLLABORATOR:
      return {
        ...state,
        enablingCollaborator: true,
        enableCollaboratorSuccess: false,
        enableCollaboratorErrorMessage: null,
      };

    case ENABLE_COLLABORATOR_SUCCESS:
      let newEnabledCollaborators = state.collaborators!.map((collaborator: Collaborator) => {
        if (collaborator.userId === action.userId) {
          let returnedCollaborator: Collaborator = {
            ...collaborator,
            active: !collaborator.active,
          };

          return returnedCollaborator;
        }

        return collaborator;
      });

      return {
        ...state,
        enablingCollaborator: false,
        enableCollaboratorSuccess: true,
        collaborators: newEnabledCollaborators,
        enableCollaboratorErrorMessage: null,
      };

    case ENABLE_COLLABORATOR_FAILED:
      return {
        ...state,
        enablingCollaborator: false,
        enableCollaboratorSuccess: false,
        enableCollaboratorErrorMessage: action.error,
      };

    case LOGOUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
